import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function ContactsTypography({
  variant,
  text,
  icon,
  onClick,
  color,
  disableHoverBorder,
}) {
  const iconStyles = {
    fontSize: {
      xs: 15.5,
      sm: 24,
    },
    p: 1,
    ml: -1,
    cursor: 'pointer',
    ...(disableHoverBorder
      ? {}
      : {
          border: '1px solid transparent',
          '&:hover': {
            border: '1px solid',
            borderColor: 'secondary.light',
            padding: '1px',
          },
        }),
  };

  return (
    <Typography
      variant={variant}
      sx={iconStyles}
      color={color}
      onClick={onClick}
    >
      {icon && icon}
      {text}
    </Typography>
  );
}

export default ContactsTypography;

ContactsTypography.propTypes = {
  variant: PropTypes.string,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  color: PropTypes.string,
  disableHoverBorder: PropTypes.bool,
};

ContactsTypography.defaultProps = {
  variant: 'body1',
  icon: null,
  onClick: undefined,
  color: 'inherit',
  disableHoverBorder: false,
};
